import { useUserEventHandler } from "events/eventHandlers/UserEventHandler";
import { useGetEducationInfo } from 'components/AppService/getEducationInfo';
import { useGAUserRole } from 'components/AppService/useGAUserRole';
import { useGAPageView } from 'components/AppService/useGAPageView';
import { useHistory } from "react-router-dom";
const useMobileRedirect = () => {
    const history = useHistory();
}
export const AppService = () => {
    useMobileRedirect();
    useUserEventHandler();
    useGetEducationInfo();
    useGAUserRole();
    useGAPageView();
    return null;
};